module.exports = __webpack_public_path__ + "media/src/images/icons/reward/certificate-34c39e0631055999df233e3a6d7aa9f9.svg";